import React from "react";
import {DocumentTypesQuery} from "../apollo/queries/DocumentTypesQuery";
import {Spinner} from "react-bootstrap";
import Select from "react-select";
import {Query} from "react-apollo";

let documentTypes = [];

export  default  class DocumentTypes extends React.Component {

  render() {

    return (
      <Query query={DocumentTypesQuery} fetchPolicy={"network-only"}
        onError={(error) => {
          this.setError(error)
        }}
      >
        {({loading, error, data}) => {
          if (loading) {
            return (
              <Spinner animation="border" role="status"><span className="sr-only">Loading...</span></Spinner>)
          } else if (error) {
            documentTypes = [];
            return (
              <>
                <label>{this.props.label}</label>
                <Select options={documentTypes}
                  onChange={this.props.handleChange}
                  value={this.props.documentType}
                />
              </>
            )
          }
          else if (data) {
            documentTypes = [];
            data.documentTypes.forEach((item) => {
              documentTypes.push({label: item.description, value: item.id})
            });

            return (
              <>
                <label>{this.props.label}</label>
                <Select options={documentTypes}
                  onChange={e=>this.props.handleChange(e, this.props.name)}
                  value={this.props.documentType}
                />
              </>)
          }
        }}

      </Query>
    )
  }
}
